import { useTranslation } from 'react-i18next'
import { mdiUpload } from '@mdi/js'
import { AppIcon } from '../ui/icon'

/**
 * The full-viewport answer to a drag in flight (spec 2026-09-09-01 § 3).
 *
 * Rendered while `useGlobalFileDrop` reports a drag carrying files. It is
 * deliberately `pointer-events-none`: the overlay is feedback, not a target —
 * the `drop` listener is on `window`, so intercepting the pointer here would
 * only add a way for the drop to land on nothing.
 */
export function FileDropOverlay({ label, testId = 'file-drop-overlay' }: { label?: string; testId?: string }) {
    const { t } = useTranslation('common')

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-background/85 pointer-events-none"
            data-testid={testId}
            aria-hidden
        >
            <div className="rounded-2xl border-2 border-dashed border-primary px-8 py-6 text-center">
                <AppIcon path={mdiUpload} size="xl" className="mx-auto text-primary" />
                <p className="mt-3 text-sm font-medium text-foreground">
                    {label ?? t('drop_files_here', { defaultValue: 'Déposez vos fichiers ici' })}
                </p>
            </div>
        </div>
    )
}
